import React, { useState } from 'react';


const BlogSection = () => {


    return (

        <section className="wpo-blog-section section-padding" id='blog'>
            <div className="container">
                
            </div>
        </section>
    );
}

export default BlogSection;